import { useEffect, Dispatch, SetStateAction, SyntheticEvent } from 'react';

export function useTouchStartNavigate<S extends HTMLElement | undefined>(
  [node, setRef]: [S, Dispatch<SetStateAction<S>>],
  {
    isOpen,
    isLoading,
    openMenu,
    closeMenu
  }: { isOpen: boolean; isLoading: boolean; openMenu: () => void; closeMenu: () => void }
): [S, Dispatch<SetStateAction<S>>] {
  useEffect(() => {
    function handleMenuItemClick(e: SyntheticEvent | TouchEvent) {
      if (e.type === 'touchstart' && !isOpen) {
        !isLoading && openMenu();
        e.preventDefault();
      } else if (e.type === 'click') {
        closeMenu();
      }
    }
    node && node.addEventListener('touchstart', handleMenuItemClick, { passive: false });
    return () => {
      node && node.removeEventListener('touchstart', handleMenuItemClick);
    };
  }, [isOpen, isLoading, openMenu, closeMenu, node]);

  return [node, setRef];
}
